"use client";
import React, { useState } from "react";
import "../../assets/css/bridgeayu.css";
import "../../assets/css/new-website.css";
import Popup_Main from "../element/component/Popup_Main";
import ReachToUsForm from "../element/ReachToUsForm";
const therapies = [
  {
    title: "Head, Face & Foot",
    image: "https://images.unsplash.com/photo-1540555700478-4be289fbecef?auto=format&fit=crop&w=900&q=85",
    items: ["Shirodhara", "Shiro Abhyanga", "Pada Abhyanga", "Mukha Abhyanga"],
  },
  {
    title: "Eye & Nasal",
    image: "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?auto=format&fit=crop&w=900&q=85",
    items: ["Netra Abhyanga", "Tarpana", "Nasya"],
  },
  {
    title: "Localised Oil Therapies",
    image: "https://images.unsplash.com/photo-1600334129128-685c5582fd35?auto=format&fit=crop&w=900&q=85",
    items: ["Kati Basti", "Greeva Basti", "Janu Basti"],
  },
  {
    title: "Specialised Procedures",
    image: "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?auto=format&fit=crop&w=900&q=85",
    items: ["Sneha Basti", "SABS Therapy"],
  },
];
const faqs = [
  {
    question: "Do I need to know my dosha before booking?",
    answer:
      "No. Your Ayurvedic physician will assess your constitution alongside your health history, current concerns and lifestyle.",
  },
  {
    question: "Can I continue my existing medicines?",
    answer:
      "Bring a list of all medicines and supplements to your consultation. Do not stop or change prescribed medicines without advice from the clinician managing your treatment. Your Ayurvedic physician will consider them when recommending care.",
  },
  {
    question: "How many sessions will I need?",
    answer:
      "The number and frequency of sessions depend on your assessment and recommended care plan. The team will explain the proposed duration, schedule and costs before treatment begins.",
  },
];
const elements = [
  { name: "Space", icon: "◌", tone: "sage" },
  { name: "Air", icon: "≋", tone: "sage" },
  { name: "Fire", icon: "♨", tone: "gold" },
  { name: "Water", icon: "♧", tone: "blue" },
  { name: "Earth", icon: "♧", tone: "sage" },
];
function SectionLabel({ children }) {
  return <div className="ba-section-label"><span>{children}</span><i /></div>;
}
function ConsultationLink({ className = "", onClick }) {
  return (
    <button
        type="button"
        className={`ba-button ${className}`}
        onClick={onClick}
        >
        Book a Consultation <span aria-hidden="true">→</span>
    </button>
    );
}
export default function BridgeAyu() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [openFaq, setOpenFaq] = useState(-1);
  const [isOpen, setIsOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);
  return (
    <main className="bridgeayu">
      <header className="ba-header">
        <a
            className="ba-brand"
            href="#top"
            aria-label="BridgeAyu home"
            onClick={closeMenu}
            >
            <img
                className="ba-brand-logo"
                src="https://bridgehealth.in/images/new-website/bhlogo.webp"
                alt="Bridge Health"
            />
        </a>
        <button
          className="ba-menu-toggle"
          type="button"
          aria-label={menuOpen ? "Close navigation" : "Open navigation"}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span /><span /><span />
        </button>
        <nav className={menuOpen ? "ba-nav ba-nav-open" : "ba-nav"} aria-label="Main navigation">
          <a href="#about" onClick={closeMenu}>About</a>
          <a href="#care" onClick={closeMenu}>Our Care</a>
          <a href="#therapies" onClick={closeMenu}>Therapies</a>
          <a href="#visit" onClick={closeMenu}>Your Visit</a>
          <ConsultationLink className="ba-nav-cta" onClick={() => setIsOpen(true)} />
        </nav>
      </header>
      <section className="ba-hero" id="top">
        <div className="ba-hero-content">
          <p className="ba-eyebrow">TRADITIONAL WISDOM. PERSONALISED CARE.</p>
          <h1>Ayurveda<br />for Modern Life</h1>
          <p className="ba-hero-copy">Personalised Ayurvedic care for your health concerns and everyday well-being.</p>
          <ConsultationLink onClick={() => setIsOpen(true)} />
        </div>
        <div className="ba-hero-image" role="img" aria-label="A calming Ayurvedic wellness treatment" />
      </section>
      <section className="ba-understanding ba-section" id="about">
        <div className="ba-understanding-copy">
          <SectionLabel>UNDERSTANDING AYURVEDA</SectionLabel>
          <h2 className="health-journey-text">
                A
                  <span className="highlighted-text"> Whole-Person Approach.
                </span> Made Relevant For Today.
            </h2>
          <p>Ayurveda is a traditional Indian system of medicine that considers the whole person. Food, sleep, movement and daily routines are part of its approach to care.</p>
          <p className="ba-practical">Practical guidance for more consistent meals, movement, rest and sleep.</p>

        </div>
        <img className="ba-understanding-image" src="/images/new-website/bridgeayu/ayurvedic-bg.webp" alt="Traditional Ayurvedic herbs and a stone mortar" loading="lazy" />
      </section>
      <section className="ba-constitution ba-section">  
        <SectionLabel>YOUR CONSTITUTION</SectionLabel>
        <h2 className="health-journey-text">
                Your Constitution, 
                  <span className="highlighted-text"> Explained Simply.
                </span> 
        </h2>
        <p className="ba-section-intro">In Ayurvedic tradition, five elements are represented through three doshas.</p>
        <div className="ba-elements" aria-label="Five elements">
          {elements.map((element, index) => (
            <React.Fragment key={element.name}>
              <div className="ba-element">
                <span className={`ba-element-icon ba-${element.tone}`} aria-hidden="true">{element.icon}</span>
                <span>{element.name}</span>
              </div>
              {index < elements.length - 1 && <span className="ba-element-slash" aria-hidden="true">/</span>}
            </React.Fragment>
          ))}
        </div>
        <div className="ba-doshas">
          <article className="ba-dosha">
            <span className="ba-dosha-icon ba-dosha-vata" aria-hidden="true">◎</span>
            <h3>Vata</h3><p>Space + Air<br />Movement</p>
          </article>
          <article className="ba-dosha">
            <span className="ba-dosha-icon ba-dosha-pitta" aria-hidden="true">♨</span>
            <h3>Pitta</h3><p>Fire + Water<br />Transformation</p>
          </article>
          <article className="ba-dosha">
            <span className="ba-dosha-icon ba-dosha-kapha" aria-hidden="true">♧</span>
            <h3>Kapha</h3><p>Earth + Water<br />Structure</p>
          </article>
        </div>
        <p className="ba-constitution-note">Everyone has a combination of all three doshas. Your individual constitution, known as Prakriti, is considered alongside your health history and current needs.</p>
      </section>
      <section className="ba-meet" aria-labelledby="ba-meet-heading">
        <img src="/images/new-website/bridgeayu/ayurveda-consult.webp" alt="A physician speaking with a patient during a consultation" loading="lazy" />
        <div className="ba-meet-copy">
          <h2 className="health-journey-text">
                Meet
                  <span className="highlighted-text"> BridgeAyu
                </span> 
        </h2>
          <p>An Ayurvedic care initiative by Bridge Health, bringing together physician consultations, therapies and practical lifestyle guidance.</p>
          <p>Your care plan considers your constitution, health concerns, nutrition and daily habits.</p>
        </div>
      </section>

        <section className="ba-care ba-section" id="care">
        <div className="ba-care-leaf ba-care-leaf-top" aria-hidden="true">
            <svg viewBox="0 0 240 240" fill="none">
            <g stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
                <path d="M238 8C176 35 133 90 99 151" />
                <path d="M201 26C159 13 126 18 105 39C139 51 171 47 201 26Z" />
                <path d="M201 27L112 37" />
                <path d="M177 53C131 40 95 53 76 80C115 88 151 77 177 53Z" />
                <path d="M177 54L84 77" />
                <path d="M151 83C109 78 78 98 65 128C102 128 133 109 151 83Z" />
                <path d="M151 84L72 124" />
                <path d="M126 117C89 120 67 145 61 175C93 166 116 145 126 117Z" />
                <path d="M126 118L64 170" />
                <path d="M208 62C225 94 224 125 204 150C186 119 188 89 208 62Z" />
                <path d="M207 67L205 143" />
                <path d="M177 91C200 120 201 150 184 177C162 147 162 116 177 91Z" />
                <path d="M177 96L185 170" />
                <path d="M146 123C171 146 177 175 163 202C138 177 134 149 146 123Z" />
                <path d="M147 128L163 195" />
            </g>
            </svg>
        </div>
        <div className="ba-care-leaf ba-care-leaf-bottom" aria-hidden="true">
            <svg viewBox="0 0 200 240" fill="none">
            <g stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
                <path d="M8 236C52 173 82 104 100 13" />
                <path d="M40 188C8 165 1 136 11 106C39 127 49 157 40 188Z" />
                <path d="M40 183L13 115" />
                <path d="M57 151C24 136 12 110 18 80C45 98 59 124 57 151Z" />
                <path d="M56 147L20 88" />
                <path d="M70 116C43 94 40 66 53 40C73 65 80 91 70 116Z" />
                <path d="M69 111L55 47" />
                <path d="M30 207C61 182 90 184 114 204C85 225 55 224 30 207Z" />
                <path d="M35 207L108 204" />
            </g>
            </svg>
        </div>
        <div className="ba-care-inner">
            <div className="ba-care-heading">
            <div className="ba-section-label">
                <span>YOUR CARE</span>
            </div>
            <h2 className="health-journey-text">
                What Brings You to 
                  <span className="highlighted-text"> BridgeAyu?
                </span> 
            </h2>
            </div>
            <div className="ba-care-columns">

            <article className="ba-care-card">
                <div className="ba-care-card-heading">
                <span className="ba-care-icon" aria-hidden="true">
                    <svg viewBox="0 0 64 64" fill="none">
                    <path
                        d="M25 8H39C41 8 42 10 42 12V24H54C57 24 59 26 59 29V37C59 40 57 42 54 42H42V54C42 57 40 59 37 59H27C24 59 22 57 22 54V42H10C7 42 5 40 5 37V29C5 26 7 24 10 24H22V12C22 10 23 8 25 8Z"
                        stroke="currentColor"
                        strokeWidth="2.2"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M39 46C45 35 54 34 59 37C59 46 52 53 43 53"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M42 53L49 44"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                    />
                    </svg>
                </span>
                <h3>Medical Care</h3>
                </div>
                <ul className="ba-care-list">
                <li><span>Diabetes &amp; obesity</span></li>
                <li><span>Hypertension &amp; thyroid disorders</span></li>
                <li><span>PCOS / PCOD</span></li>
                <li><span>Joint pain, migraine &amp; chronic headache</span></li>
                <li><span>Stress disorders &amp; insomnia</span></li>
                </ul>
            </article>
   
            <article className="ba-care-card">
                <div className="ba-care-card-heading">
                <span className="ba-care-icon" aria-hidden="true">
                    <svg viewBox="0 0 64 64" fill="none">
                    <g
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <path d="M32 8V3M18 13L14 9M46 13L50 9M12 25H7M52 25H57" />
                        <path d="M22 22C22 16 26 12 32 12C38 12 42 16 42 22" />
                        <path d="M32 57C14 57 5 45 5 31C20 31 29 40 32 57Z" />
                        <path d="M32 57C50 57 59 45 59 31C44 31 35 40 32 57Z" />
                        <path d="M32 57C24 45 25 33 32 25C39 33 40 45 32 57Z" />
                        <path d="M32 57V38" />
                    </g>
                    </svg>
                </span>
                <h3>General Wellness</h3>
                </div>
                <ul className="ba-care-list">
                <li><span>Rejuvenation &amp; relaxation</span></li>
                <li><span>Nutrition &amp; lifestyle support</span></li>
                <li><span>Preventive wellness</span></li>
                <li><span>Ayurvedic cleansing consultation</span></li>
                </ul>
            </article>
            </div>
            <p className="ba-care-note">
            Care is personalised following clinical assessment.
            </p>
        </div>
        </section>

      <section className="ba-therapies ba-section" id="therapies">
        <SectionLabel>EXPLORE OUR THERAPIES</SectionLabel>

        <h2 className="health-journey-text">
                Explore Our 
                  <span className="highlighted-text"> Therapies
                </span> 
        </h2>
        <div className="ba-therapy-grid">
          {therapies.map((therapy) => (
            <article className="ba-therapy-card" key={therapy.title}>
              <img src={therapy.image} alt={`${therapy.title} Ayurvedic therapy`} loading="lazy" />
              <div className="ba-therapy-content">
                <h3>{therapy.title}</h3>
                <ul>{therapy.items.map((item) => <li key={item}>{item}</li>)}</ul>
              </div>
            </article>
          ))}
        </div>
      </section>
      <section className="ba-visit ba-section" id="visit">
        <SectionLabel>YOUR VISIT</SectionLabel>
        <h2 className="health-journey-text">
                Your Visit,
                  <span className="highlighted-text"> Step by Step.
                </span> 
            </h2>
        <div className="ba-steps">
          <article><span>01</span><h3>Consultation</h3><p>Discuss your health concerns, medical history and daily habits with an Ayurvedic physician.</p></article>
          <article><span>02</span><h3>Personalised Plan</h3><p>Receive recommendations suited to your assessment and care goals.</p></article>
          <article><span>03</span><h3>Recommended Care</h3><p>Begin the prescribed care with guidance on preparation, scheduling and what to expect.</p></article>
          <article><span>04</span><h3>Follow-up</h3><p>Review your progress and adjust your care plan where needed.</p></article>
        </div>
      </section>
      <section className="ba-faq ba-section" aria-labelledby="ba-faq-heading">
        <SectionLabel>A FEW THINGS YOU MAY WANT TO KNOW</SectionLabel>
        <h2 className="health-journey-text">
                Frequently Asked
                  <span className="highlighted-text"> Questions
                </span> 
            </h2>
        <div className="ba-faq-list">
          {faqs.map((faq, index) => (
            <article className="ba-faq-item" key={faq.question}>
              <button
                type="button"
                className="ba-faq-question"
                aria-expanded={openFaq === index}
                onClick={() => setOpenFaq(openFaq === index ? -1 : index)}
              >
                <span>{faq.question}</span><span className="ba-faq-symbol" aria-hidden="true">{openFaq === index ? "−" : "+"}</span>
              </button>
              {openFaq === index && <p className="ba-faq-answer">{faq.answer}</p>}
            </article>
          ))}
        </div>
      </section>
      <footer className="ba-footer">
        <div className="ba-footer-copy">
          <h2>Begin with a conversation.</h2>
          <p>Book your BridgeAyu consultation.</p>
          <small>Care is personalised. Outcomes vary.</small>
        </div>
        <ConsultationLink className="ba-footer-cta" onClick={() => setIsOpen(true)} />
        <div className="ba-contact">
          <a href="tel:08047093866"><span aria-hidden="true">☎</span> 080 4709 3866</a>
          <p><span aria-hidden="true">⌖</span> Bridge Health, JP Nagar, Bengaluru</p>
        </div>
        <Popup_Main isOpen={isOpen} onClose={() => setIsOpen(false)} >
            <ReachToUsForm submitted={() => setIsOpen(false)} />
        </Popup_Main>
      </footer>
    </main>
  );
}
